import React, { useEffect } from 'react'
import WhoWeAre from './WhoWeAre';
import Services from './Services';
import Scaleup from './Scaleup';
import Specs from './Specs';
import IndustriesServe from './IndustriesServe';

import HomeSlider from './HomeSlider';
import Testimonials from './Testimonials';

export default function Home() {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []); // Empty dependency array means this runs once when the component mounts
  return (
    <>
      <HomeSlider />
      <WhoWeAre />
      <Scaleup />
      <Services />
      <Specs />
      <IndustriesServe />
      {/* <Testimonials /> */}
      
    </>
  )
}
